/*
 * Navigation feature flags (design-uplift R2 — navigation rebuild, tranche 1).
 *
 * NAV_BOTTOM_TABS — dark-ship switch for the native iOS bottom tab bar that
 * replaces the desktop icon-rail (src/pages/menu/menu.jsx Drawer) on
 * authenticated routes.
 *
 *   OFF (default, env unset)        → the legacy icon-rail renders UNCHANGED.
 *   ON  (REACT_APP_NAV_BOTTOM_TABS  → the rail is replaced by <BottomTabBar/>.
 *        === "true")
 *
 * The swap is fully REVERSIBLE with NO code change (flip the env var), and the
 * rail component is PRESERVED — it is not deleted until the R2 critic panel
 * proves nav parity. See docs/contracts/qlearn-ios-r2-navigation-rebuild-v1.md
 * (Implementation contract: "feature-flag or route-guard the swap so it's
 * reversible — dark-ship pattern, per REVERSIBLE-CODE").
 */
export const NAV_BOTTOM_TABS = process.env.REACT_APP_NAV_BOTTOM_TABS === "true";
